import { tickerNotices } from "@/mocks/homeContent";

function NoticeBar() {
  const doubled = [...tickerNotices, ...tickerNotices];
  return (
    <section className="border-y border-background-200 bg-background-100 py-3">
      <div className="flex items-center gap-4 overflow-hidden px-4 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
          <i className="ri-megaphone-fill text-xs"></i>
          迁移公告
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-ticker gap-12 whitespace-nowrap">
            {doubled.map((n, i) => (
              <span
                key={i}
                className="inline-flex items-center gap-2 text-xs font-medium text-foreground-600"
              >
                <i className="ri-broadcast-line text-secondary-600"></i>
                {n}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default NoticeBar;